module.exports = __webpack_public_path__ + "static/media/CopyImage.3f3a079e.svg";